import { showBackdrop, hideBackdrop } from '../components/backdrop';
import { atQuery } from '../components/mediaQueries';

$(function () {
  const $langSwitcher = $('.lang-switcher');
  const $langSwitcherModal = $('.lang-switcher__modal');

  if (!$langSwitcher.length || !$langSwitcherModal.length) return;

  const $langSwitcherModalClose = $('.lang-switcher__modal__close');

  $langSwitcher.on('click', function () {
    $langSwitcherModal.addClass('open');
    $('body').addClass('country-lang-open');

    atQuery('min', 'md', () => {
      showBackdrop();
    });
  });

  const $activeLang = $langSwitcher.find('.lang-switcher__active-lang');
  if ($activeLang.length <= 0) return;

  $activeLang.on('blur', function (e) {
    if (!e.relatedTarget || !e.relatedTarget.closest('.lang-switcher__dropdown')) {
      $langSwitcher.removeClass('open');
    }
  });

  $($langSwitcherModalClose).on('click', function(e) {
    e.stopPropagation();
    $langSwitcherModal.removeClass('open');
    $('body').removeClass('country-lang-open');

    atQuery('min', 'md', () => {
      hideBackdrop();
    });
  });
});
